import {
  ApartmentOutlined,
  DashboardOutlined,
  FlagOutlined,
  GoldOutlined,
  IdcardOutlined,
  MessageOutlined,
  UnorderedListOutlined,
  SettingOutlined,
  UserSwitchOutlined,
  ApiOutlined,
  RocketOutlined,
  WhatsAppOutlined,
  AuditOutlined,
  SwapOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Link, Outlet, useLocation } from "react-router-dom";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { usePermissions } from "../../hooks/usePermissions";

const paths = [
  { path: "/settings/general/org-levels", key: "1" },
  { path: "/settings/general/designations", key: "2" },
  { path: "/settings/general/plan-templates", key: "3" },
  { path: "/settings/general/plan-groups", key: "4" },
  { path: "/settings/general/plan-attributes", key: "5" },
  { path: "/settings/general/dropdown-attributes", key: "6" },
  { path: "/settings/general/scales", key: "7" },
  { path: "/settings/general/position-features", key: "8" },
  { path: "/settings/general/chatbot", key: "9" },
  { path: "/settings/general/zoho-crm", key: "10" },
  { path: "/settings/general/odoo-crm", key: "11" },
  { path: "/settings/general/ehrm-config", key: "12" },
  { path: "/settings/general/clickup-config", key: "13" },
  { path: "/settings/general/whatsapp-config", key: "14" },
  { path: "/settings/general/login-audit", key: "15" },
  { path: "/settings/general/sso-config", key: "16" },
  { path: "/settings/general/cycle-lock", key: "17" },
];

function General() {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  let curLocation = useLocation();
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;
  const { hasZohoPermission, hasOdooPermission } = usePermissions();

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[3] === "plan-templates") {
        setMainKey("3");
      }
    });
  }, [curLocation]);

  return (
    <>
      <style>
        {`
          .custom-general-menu .ant-menu-item {
            margin: 4px 8px !important;
            border-radius: 8px !important;
            transition: all 0.3s ease !important;
          }
          
          .custom-general-menu .ant-menu-item:hover {
            background-color: #D14A1F !important;
            color: white !important;
          }
          
          .custom-general-menu .ant-menu-item:hover .ant-menu-item-icon {
            color: white !important;
          }
          
          .custom-general-menu .ant-menu-item:hover a {
            color: white !important;
          }
          
          .custom-general-menu .ant-menu-item-selected {
            background-color: #D14A1F !important;
            color: white !important;
            border-radius: 8px !important;
          }
          
          .custom-general-menu .ant-menu-item-selected .ant-menu-item-icon {
            color: white !important;
          }
          
          .custom-general-menu .ant-menu-item-selected a {
            color: white !important;
          }
          
          .custom-general-menu .ant-menu-item-selected::after {
            display: none !important;
          }
        `}
      </style>
      <Content style={{ backgroundColor: "#fff" }}>
        <div className="flex">
          <div
            style={{
              height: proHeight - 64,
              overflow: "auto",
            }}
            className="w-48 border-r custom-scroll"
          >
            <div
              className="shadow-sm border-b text-lg pri-font"
              style={{ padding: "14px 24px", backgroundColor: "#fff" }}
            >
              General
            </div>
            <Menu
              className="transparent-scroll custom-general-menu"
              mode="inline"
              selectedKeys={[mainKey]}
              style={{
                backgroundColor: "#fff",
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
              }}
            >
              {permissionAbility(userLevel, "org-level", "view") && (
                <Menu.Item key="1" icon={<ApartmentOutlined />}>
                  <Link to="/settings/general/org-levels">Org Levels</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "designations", "view") && (
                <Menu.Item key="2" icon={<IdcardOutlined />}>
                  <Link to="/settings/general/designations">Designations</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-templates", "view") && (
                <Menu.Item key="3" icon={<FlagOutlined />}>
                  <Link to="/settings/general/plan-templates">
                    Plan Templates
                  </Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-groups", "view") && (
                <Menu.Item key="4" icon={<GoldOutlined />}>
                  <Link to="/settings/general/plan-groups">Plan Groups</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-attributes", "view") && (
                <Menu.Item key="5" icon={<UnorderedListOutlined />}>
                  <Link to="/settings/general/plan-attributes">
                    Plan Attributes
                  </Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-attributes", "view") && (
                <Menu.Item key="6" icon={<UnorderedListOutlined />}>
                  <Link to="/settings/general/dropdown-attributes">
                    Dropdown Attributes
                  </Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "scales", "view") && (
                <Menu.Item key="7" icon={<DashboardOutlined />}>
                  <Link to="/settings/general/scales">Scales</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "positions", "view") && (
                <Menu.Item key="8" icon={<UserSwitchOutlined />}>
                  <Link to="/settings/general/position-features">Position Features</Link>
                </Menu.Item>
              )}
              <Menu.Item key="9" icon={<MessageOutlined />}>
                <Link to="/settings/general/chatbot">Chatbot</Link>
              </Menu.Item>
              <Menu.Item key="10" icon={<SettingOutlined />}>
                <Link to="/settings/general/zoho-crm">Zoho CRM</Link>
              </Menu.Item>
              <Menu.Item key="11" icon={<SettingOutlined />}>
                <Link to="/settings/general/odoo-crm">Odoo CRM</Link>
              </Menu.Item>
              <Menu.Item key="12" icon={<ApiOutlined />}>
                <Link to="/settings/general/ehrm-config">EHRM Config</Link>
              </Menu.Item>
              <Menu.Item key="13" icon={<RocketOutlined />}>
                <Link to="/settings/general/clickup-config">ClickUp Config</Link>
              </Menu.Item>
              <Menu.Item key="14" icon={<WhatsAppOutlined />}>
                <Link to="/settings/general/whatsapp-config">WhatsApp Config</Link>
              </Menu.Item>
              {permissionAbility(userLevel, "general", "view") && (
                <Menu.Item key="15" icon={<AuditOutlined />}>
                  <Link to="/settings/general/login-audit">Login Audit</Link>
                </Menu.Item>
              )}
              <Menu.Item key="16" icon={<SwapOutlined />}>
                <Link to="/settings/general/sso-config">SSO Config</Link>
              </Menu.Item>
              <Menu.Item key="17" icon={<LockOutlined />}>
                <Link to="/settings/general/cycle-lock">Cycle Lock</Link>
              </Menu.Item>
            </Menu>
          </div>
          <div className="w-full" style={{ height: proHeight - 64, overflow: "auto" }}>
            <Outlet />
          </div>
        </div>
      </Content>
    </>
  );
}

export default General;
